import { render, staticRenderFns } from "./teaClassroomBehavior.vue?vue&type=template&id=7f109432&scoped=true"
import script from "./teaClassroomBehavior.vue?vue&type=script&lang=js"
export * from "./teaClassroomBehavior.vue?vue&type=script&lang=js"
import style0 from "./teaClassroomBehavior.vue?vue&type=style&index=0&id=7f109432&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f109432",
  null
  
)

export default component.exports